import { Box, BoxProps } from "@mui/material";
import React from "react";

export const MessageContainer = (props: BoxProps) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                flexGrow: 2,
                height: "100%",
            }}
        >
            {props.children}
        </Box>
    );
};
